const neo4regex = /^(4$|4\.[0-9])/;
const neo3regex = /^(3$|3\.[0-9])/;

export const needsMigration = (dbVersion: string): boolean => {
  return neo4regex.test(dbVersion) || neo3regex.test(dbVersion);
};
